module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "head-0"
  }, [_vm._t("head-row-0")], 2), _vm._v(" "), _c('tr', {
    staticClass: "head-1"
  }, [_vm._t("head-row-1")], 2), _vm._v(" "), _c('tr', {
    staticClass: "head-2"
  }, [_vm._t("head-row-2")], 2)]), _vm._v(" "), _vm._t("body")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-219e6f5b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/table/ForecastTable.vue
// module id = 3075
// module chunks = 0